import { render, staticRenderFns } from "./wordDetail.vue?vue&type=template&id=d36d93f2&scoped=true"
import script from "./wordDetail.vue?vue&type=script&lang=js"
export * from "./wordDetail.vue?vue&type=script&lang=js"
import style0 from "./wordDetail.vue?vue&type=style&index=0&id=d36d93f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36d93f2",
  null
  
)

export default component.exports